import { createTheme } from "@mui/material/styles";

const darkTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      xsm: 400,
      sm: 600,
      smd: 750,
      md: 900,
      mlg: 1050,
      lg: 1200,
      lxl: 1350,
      xl: 1536,
    },
  },
  palette: {
    mode: "dark",
    primary: {
      main: "#90caf9",
    },
    secondary: {
      main: "#ffb74d",
    },
    background: {
      default: "#121212",
      paper: "#1d1d1d",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
    border: {
      primary: "#D9D9D9",
      secondary: "#E54B3E",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2.5rem",
      fontWeight: 700,
      color: "#ffffff", // White heading text
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 700,
      color: "#ffffff",
    },
    h3: {
      fontSize: "1.75rem",
      fontWeight: 600,
      color: "#ffffff",
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 600,
      color: "#ffffff",
    },
    h5: {
      fontSize: "1.25rem",
      fontWeight: 500,
      color: "#ffffff",
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 500,
      color: "#ffffff",
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.5,
      color: "#ffffff", // White body text
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: 1.5,
      color: "#bbbbbb", // Light grey body text
    },
    button: {
      fontSize: "1rem",
      textTransform: "none", // Disable uppercase
      fontWeight: 500,
    },
    caption: {
      fontSize: "0.75rem",
      fontWeight: 400,
      color: "#bbbbbb",
    },
  },
});

export default darkTheme;
